/**
 * Maps Drupal / Typesense product documents to the shape expected by shared
 * WooCommerce merchandising components (ProductListing, etc.), using the same
 * logical keys as Display Field Mapping (autocompleteDisplay.productFieldMap).
 */

export const DEFAULT_DRUPAL_PRODUCT_FIELD_MAP = {
	url: 'url',
	image: 'image_url',
	title: 'product_title',
	description: 'body',
	price: 'price_number',
	priceCurrency: 'price_currency',
	vendor: 'brand',
	sku: 'sku',
};

export function mergeDrupalProductFieldMap(stored) {
	if (!stored || typeof stored !== 'object') return { ...DEFAULT_DRUPAL_PRODUCT_FIELD_MAP };
	const out = { ...DEFAULT_DRUPAL_PRODUCT_FIELD_MAP };
	for (const key of Object.keys(DEFAULT_DRUPAL_PRODUCT_FIELD_MAP)) {
		if (Object.prototype.hasOwnProperty.call(stored, key)) {
			out[key] = stored[key] != null ? String(stored[key]).trim() : '';
		}
	}
	return out;
}

export function normalizeDrupalDocForMerchUI(raw, productFieldMap) {
	if (!raw || typeof raw !== 'object') return raw;
	const map = mergeDrupalProductFieldMap(productFieldMap);
	const pick = (logicalKey) => {
		const fieldName = map[logicalKey];
		if (!fieldName || !String(fieldName).trim()) return undefined;
		return raw[fieldName];
	};

	let priceVal = pick('price');
	if (priceVal === undefined || priceVal === null) {
		priceVal = raw.price_number ?? raw.price;
	}
	const parsePrice = (v) => {
		if (typeof v === 'number' && Number.isFinite(v)) return v;
		if (v == null) return NaN;
		const s = String(v).replace(/[^0-9.-]/g, '');
		return parseFloat(s);
	};
	const priceNum = parsePrice(priceVal);
	const price = Number.isFinite(priceNum) ? priceNum : 0;

	const imageVal = pick('image');
	const image =
		imageVal != null && String(imageVal).trim()
			? String(imageVal).trim()
			: String(raw.image_url || raw.image || '').trim() || '';

	const titleVal = pick('title');
	const title =
		titleVal != null && String(titleVal).trim()
			? String(titleVal).trim()
			: String(raw.product_title || raw.title || '').trim() || '';

	const skuVal = pick('sku');
	const sku =
		skuVal != null && String(skuVal).trim()
			? String(skuVal).trim()
			: String(raw.sku || '').trim() || '';

	return {
		...raw,
		image,
		title,
		sku,
		price,
		sale_price: 0,
		regular_price: price,
		variants: undefined,
	};
}

export function normalizeDrupalMerchProductList(list, productFieldMap) {
	if (!Array.isArray(list)) return [];
	return list.map((p) => normalizeDrupalDocForMerchUI(p, productFieldMap));
}
